import { useState, type FormEvent } from 'react';
import { useOturum } from '../lib/oturum.js';
import { Girdi } from '../bilesenler/form.js';
import { NeroLogo } from '../bilesenler/Logo.js';
import { UyariSerit } from '../bilesenler/temel.js';

export function Giris() {
  const { girisYap, suresiDoldu } = useOturum();
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState<string | null>(null);
  const [calisiyor, setCalisiyor] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setCalisiyor(true);
    try {
      await girisYap(kullaniciAdi.trim(), sifre);
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Giriş yapılamadı');
      setCalisiyor(false);
    }
  }

  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100%', padding: 'var(--b6)' }}>
      <div style={{ width: '100%', maxWidth: 360 }}>
        <div style={{ marginBottom: 'var(--b8)' }}>
          <NeroLogo yukseklik={30} />
          <div style={{ fontSize: 'var(--p-12)', color: 'var(--metin-3)', marginTop: 'var(--b3)' }}>
            İşletme sistemi
          </div>
        </div>

        <form onSubmit={gonder} className="sutun">
          <Girdi
            etiket="Kullanıcı adı"
            value={kullaniciAdi}
            onChange={setKullaniciAdi}
            autoComplete="username"
            autoFocus
            required
          />
          <Girdi
            etiket="Şifre"
            type="password"
            value={sifre}
            onChange={setSifre}
            autoComplete="current-password"
            required
          />
          {suresiDoldu && !hata && (
            <UyariSerit ton="uyari">
              Güvenlik için oturumunuz kapatıldı. Devam etmek için tekrar giriş yapın.
            </UyariSerit>
          )}
          {hata && <UyariSerit ton="kritik">{hata}</UyariSerit>}
          <button className="btn btn-birincil btn-buyuk btn-tam" type="submit" disabled={calisiyor}>
            {calisiyor ? 'Giriş yapılıyor…' : 'Giriş yap'}
          </button>
        </form>

        <p style={{ marginTop: 'var(--b6)', fontSize: 'var(--p-12)', color: 'var(--metin-3)', textAlign: 'center' }}>
          Şifrenizi bilmiyorsanız yöneticinize başvurun.
        </p>
      </div>
    </div>
  );
}
